export const useCategoryBreadcrumb = () => {
	const { kebabCase } = useNorcePwa();
	const { t } = useI18n();
	const localePath = useLocalePath();
	const requestURL = useRequestURL();
	const domain = computed(() => requestURL.origin);

	const buildBreadcrumbItems = (
		category: { Name?: string | null; Parent?: unknown } | null | undefined
	): { position: number; name: string; item: string }[] => {
		// Always starts with Home, so a page without a category (e.g. a PDP whose
		// product has none) still gets a valid Home > page trail. Category pages
		// only emit their BreadcrumbList for more than that one item.
		const chain: (typeof category)[] = [];
		const visited = new Set<typeof category>();
		let current: typeof category = category;
		while (current && !visited.has(current)) {
			visited.add(current);
			chain.unshift(current);
			current = current.Parent as typeof category;
		}
		const items: { position: number; name: string; item: string }[] = [
			{
				position: 1,
				name: t("Home"),
				item: `${domain.value}${localePath("/")}`
			}
		];
		let cumulativePath = "";
		chain.forEach((cat, i) => {
			cumulativePath += `/${kebabCase(cat?.Name || "")}`;
			items.push({
				position: i + 2,
				name: cat?.Name || "",
				item: `${domain.value}${localePath(cumulativePath)}`
			});
		});
		return items;
	};

	return { buildBreadcrumbItems, domain };
};
